import { SubmitStatus } from '../../models/enhancement'

export const isEnhancementSubmitStatus = (requestType: string): boolean =>
  SubmitStatus.PENDING === requestType ||
  SubmitStatus.DECLINED === requestType ||
  SubmitStatus.CANCELLED === requestType ||
  SubmitStatus.APPROVED === requestType ||
  SubmitStatus.SUBMITTED === requestType ||
  SubmitStatus.AMENDED === requestType
